import { registerLocaleData } from '@angular/common';
import {
	HTTP_INTERCEPTORS,
	HttpClient,
	provideHttpClient,
	withInterceptorsFromDi,
} from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { APP_ROUTES } from '@app/app.routes';
import { LANG } from '@app/shared/interfaces/lang.enum';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EncryptionInterceptor } from './core/interceptors/encryption.interceptor';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { WafInterceptor } from './core/interceptors/waf.interceptor';
import { MatDialogModule } from '@angular/material/dialog';
registerLocaleData(localeEs, LANG.ES);
registerLocaleData(localeEn, LANG.EN);
export function httpLoaderFactory(httpClient: HttpClient) {
	return new TranslateHttpLoader(httpClient);
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(APP_ROUTES, 
			withRouterConfig({paramsInheritanceStrategy: 'always'})
		),
		importProvidersFrom(
			TranslateModule.forRoot({
				loader: {
					provide: TranslateLoader,
					useFactory: httpLoaderFactory,
					deps: [HttpClient],
				},
			}),
			MatDialogModule
		),
		{ provide: LOCALE_ID, useValue: LANG.ES },
		{ provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: WafInterceptor, multi: true },
		provideAnimations(),
		provideHttpClient(withInterceptorsFromDi()),
	],
};